import { Component, OnInit, Input, Output, EventEmitter, QueryList, ViewChildren } from '@angular/core';
import { ContentfulContentRow } from './contentful-content-row';
import { ContentfulInfoBlockComponent } from '../contentful-info-block/contentful-info-block.component';
import { InfoBlockBehaviour } from '../info-block-behaviour';
@Component({
    selector: 'sbw-contentful-content-row',
    templateUrl: './contentful-content-row.component.html',
    styleUrls: ['./contentful-content-row.component.css']
})
export class ContentfulContentRowComponent implements OnInit {

    @Input() ContentRow: ContentfulContentRow
    @Input() InfoBlockBehaviour: InfoBlockBehaviour
    @Output() onToggleExpandRow = new EventEmitter();

    @ViewChildren(ContentfulInfoBlockComponent) infoBlocks: QueryList<ContentfulInfoBlockComponent>

    constructor() { }

    ngOnInit() {

    }

    public onToggleExpandInfoBlock(event: any) {
        if (this.onToggleExpandRow)
            this.onToggleExpandRow.emit({
                'target': this,
                'expanded': event.expanded
            })

    }

    public collapse() {
        this.infoBlocks.forEach(infoBlock => {
            infoBlock.collapse();
        });
    }
}
